export const TRANSLATION_PATH = (route) => {
  return `views.app.manage.devices.addDevice.${route}`;
};
